import axios from '@axios'

const PREFIX = '/portal-propostas'

export default {
  source: null,

  getHistoricos(id) {
    return axios.get(`${PREFIX}/${id}/historicos`)
  },

  getTramites(id) {
    return axios.get(`${PREFIX}/${id}/tramites`)
  },

  getVisualizacoes(id) {
    return axios.get(`${PREFIX}/${id}/visualizacoes`)
  },

  getPropostas(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getPropostaDocumentos(propostaId) {
    return axios.get(`${PREFIX}/${propostaId}/documentos`)
  },
  getDadosUpload(id, file) {
    return axios.post(`${PREFIX}/${id}/dados-upload`, file)
  },
  atualizaDocumentoStatusAguardando(id, file, observacao) {
    return axios.post(`${PREFIX}/proposta-documentos/${id}/alterar-status-aguardando?observacao=${observacao}`, file)
  },
  aprovarProposta(id, status, jusObs, dadosContratante) {
    return axios.post(`${PREFIX}/${id}?naoAprovar=${status}&justificativa=${jusObs}`, dadosContratante)
  },

  getPDFPropostaContrato(id, pdfProposta) {
    return axios.get(`${PREFIX}/${id}/pdf-proposta?pdfProposta=${pdfProposta}`)
  },

  AddVisualizacaoPortal(propostas) {
    return axios.post(`${PREFIX}/email-proposta`, propostas)
  },

  getRelatorioProposta(id) {
    return axios.get(`${PREFIX}/relatorio-proposta/${id}`)
  },

  getRelatorioChecklist(id) {
    return axios.get(`${PREFIX}/relatorio-checklist/${id}`)
  },

  confirmarEscolhaPacote(propostaExternaId, pacoteEscolhidoId) {
    return axios.post(`${PREFIX}/escolha-pacote/${propostaExternaId}`, pacoteEscolhidoId)
  },

  enviarChecklist(proposta) {
    return axios.post(`${PREFIX}/enviar-checklist`, proposta)
  },

  salvarChecklistExterno(proposta) {
    return axios.post(`${PREFIX}/salvar-checklist`, proposta)
  },

  getEmpresasPreGeracao(respostas, tokenCancel) {
    this.source = tokenCancel.source()
    return axios.post(`${PREFIX}/empresas-geracao`, respostas, { cancelToken: this.source.token })
  },

  getSociosMatriz(request, tokenCancel) {
    this.source = tokenCancel.source()
    return axios.post(`${PREFIX}/matriz-socios`, request, { cancelToken: this.source.token })
  },

  validaCertificado(certificado, senha) {
    const formData = new window.FormData()
    formData.append('file', certificado.file, certificado.filename || certificado.name)
    formData.append('body', senha)
    return axios.post(`${PREFIX}/valida-certificado`, formData)
  },

  salvarPreGeracao(id, form, constituicao) {
    return axios.post(`${PREFIX}/salvar-geracao-contrato/${id}?constituicao=${constituicao}`, form)
  },

  salvarEEnviarPreGeracao(id, form, constituicao) {
    return axios.post(`${PREFIX}/salvar-enviar/${id}?constituicao=${constituicao}`, form)
  },

  notificaPropostaPendenteDeAnalise(id) {
    return axios.post(`${PREFIX}/notificar-analise/${id}`)
  },

  getPreGeracaoContrato(id) {
    return axios.get(`${PREFIX}/pre-geracao/${id}`)
  },

  getArquivoContratual(id) {
    return axios.get(`${PREFIX}/arquivo-contratual/${id}`)
  },

  getArquivoOutros(id) {
    return axios.get(`${PREFIX}/arquivo-outros/${id}`)
  },

  getPacotesEServicos(id) {
    return axios.get(`${PREFIX}/${id}/pacote-servico`)
  },

  addVisualizacaoPreGeracao(id) {
    return axios.post(`${PREFIX}/${id}/visualizacoes/pre-geracao`)
  },

  addVisualizacaoEscolhaPacote(id) {
    return axios.post(`${PREFIX}/${id}/visualizacoes/escolha-pacote`)
  },

  addVisualizacaoChecklist(id) {
    return axios.post(`${PREFIX}/${id}/visualizacoes/checklist`)
  },

  buscaPropostaContratante(propostaContratante) {
    return axios.post(`${PREFIX}/proposta-contratante`, propostaContratante)
  },

  cancelarBusca() {
    this.source.cancel()
  },
}
